<template>
    <v-dialog v-model="dialog" max-width="500px" persistent @keydown.esc="chiudi">
        <v-card>
            <v-card-title class="text-h6">Esporta corsi svolti</v-card-title>
            <v-card-text>
                <v-select v-model="filtro.CorsoId" :items="corsi" item-text="nomeBreve" item-value="corsoId"
                    label="Corso (opzionale)" clearable dense />
                <v-select v-model="filtro.Anno" :items="anni" label="Anno (opzionale)" clearable dense />
                <v-select v-model="filtro.TipoCertificazione" :items="['FSC', 'PEFC', 'FPC']"
                    label="Certificato (opzionale)" clearable dense />
                <v-select v-model="filtro.CompanyCode" :items="aziende" item-text="ragioneSociale"
                    item-value="companyCode" label="Azienda (opzionale)" clearable dense />
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn @click="chiudi">Annulla</v-btn>
                <v-btn color="primary" @click="esporta">Esporta</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { get_corsiSvoltiExcel } from "@/api/api.formazione.js";

var XLSX = require("xlsx");

export default {
    props: {
        dialog: { type: Boolean, default: false },
        corsi: { type: Array, default: () => [] },
        aziende: { type: Array, default: () => [] },
    },

    data: () => ({
        filtro: { CorsoId: null, Anno: null, CompanyCode: "", TipoCertificazione: "" },
    }),

    methods: {
        async esporta() {
            this.$wait.open();
            try {
                const res = await get_corsiSvoltiExcel(this.filtro);
                const sheetData = res.data;

                const workbook = XLSX.utils.book_new();
                const ws = XLSX.utils.aoa_to_sheet(sheetData);
                ws["!cols"] = [{ wch: 30 }, { wch: 14 }, { wch: 35 }, { wch: 30 }, { wch: 8 }, { wch: 25 }, { wch: 14 }, { wch: 20 }];
                XLSX.utils.book_append_sheet(workbook, ws, "CorsiSvolti");

                XLSX.writeFile(workbook, "CorsiSvolti.xlsx", { bookType: "xlsx", bookSST: false, type: "array" });
            } finally {
                this.$wait.close();
            }
        },

        chiudi() {
            this.$emit("close");
        },
    },

    computed: {
        anni() {
            const annoCorrente = new Date().getFullYear();
            const lista = [];
            for (let a = annoCorrente + 1; a >= annoCorrente - 5; a--) lista.push(a);
            return lista;
        },
    },
};
</script>
